import React from "react";
import Moment from "moment";
import EmploymentHistoryTable from "./EmplomentHistoryTable";
import { FORM_ID } from "../../../constants/Forms";
import {
  deleteEmploymentHistoryInformation,
  deleteEmploymentBreakHistoryInformation,
} from "../../../api/makeAPIRequest";
import NavigationButtons from "../../SharedComponents/NavigationButtons";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../constants/Contract";
import { UtagTracking } from "../../../utils/utag-tracking";
import EmploymentHistoryModal from "./AddEmploymentHistoryModal";
import { organizeEmpHistoryData } from "../../../common/Functions";
import Toast from "../../SharedComponents/Toast";

class EmploymentHistoryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
    this.getEmploymentHistory = this.getEmploymentHistory.bind(this);
    this.showAddModal = this.showAddModal.bind(this);
    this.showAddModalFromTable = this.showAddModalFromTable.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.showDeletedAlert = this.showDeletedAlert.bind(this);
    this.closeDeletedAlert = this.closeDeletedAlert.bind(this);
    this.reviewEditClick = this.reviewEditClick.bind(this);
    this.enableNextButton = this.enableNextButton.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleShowBackModal = this.handleShowBackModal.bind(this);
  }

  initialState() {
    return {
      show_modal: false,
      emp_hist_data: [],
      date_list: [],
      show_experience_added_alert: false,
      show_experience_deleted_alert: false,
      is_next_disabled: true,
      reviewEditData: "",
      oktasubid: "",
      candidateId: 0,
      added_saved: "added",
    };
  }
  async componentDidMount() {
    await this.setState({
      oktasubid: this.props.subId,
      candidateId: this.props.candidateId,
    });
    this.getEmploymentHistory();
    UtagTracking.sendPageNameView(
      "employmenthistoryform",
      this.props.candidateId,
      this.props.agencynumber,
      this.props.contracttypeid,
    );
  }

  async closeAddModal(data) {
    if (data !== null) {
      let newEmpHistData = [...this.state.emp_hist_data];

      // if index is found, then overwrite spot in arraylist. if not, add new data to arraylist
      const index = newEmpHistData.findIndex((item) => item.id === data.id);
      index !== -1 ? (newEmpHistData[index] = data) : newEmpHistData.push(data);

      await this.showAlert();
      this.props.saveEmpHistInfo(newEmpHistData);
      this.setState({ emp_hist_data: newEmpHistData });
      await this.getEmploymentHistory();
    }

    this.setState({ show_modal: false, reviewEditData: "" });
  }
  async closeAlert() {
    await this.setState({
      show_experience_added_alert: false,
      added_saved: "added",
    });
  }
  async closeDeletedAlert() {
    await this.setState({ show_experience_deleted_alert: false });
  }
  async deleteData(item) {
    item.companyname === null
      ? await deleteEmploymentBreakHistoryInformation(this.props.subId, item.id)
      : await deleteEmploymentHistoryInformation(this.props.subId, item.id);

    let newEmploymentHistory = this.state.emp_hist_data.filter(
      (addressHistItem) => addressHistItem !== item,
    );

    this.props.saveEmpHistInfo(newEmploymentHistory);

    await this.getEmploymentHistory();
    await this.showDeletedAlert();
    window.scrollTo(0, 0);
  }
  enableNextButton() {
    var addHistoryLink = document.getElementById("add_emp_history");

    let isEmpHistoryComplete =
      addHistoryLink === null && this.state.emp_hist_data.length > 0;

    this.setState({ is_next_disabled: !isEmpHistoryComplete });
    this.props.isFormComplete(isEmpHistoryComplete);
  }
  async getEmploymentHistory() {
    const newEmpHist = organizeEmpHistoryData([...this.props.empHistoryData]);
    await this.setState({ emp_hist_data: newEmpHist });
    window.scrollTo(0, 0);
    this.props.refreshPSR();
    this.enableNextButton();
  }

  async reviewEditClick(job) {
    await this.setState({
      reviewEditData: job,
      added_saved: "saved",
      show_modal: true,
    });
    //hide popup menu
    let myRef = document.getElementById("top_element");
    myRef.click();
  }
  async showAddModal() {
    await this.setState({
      show_modal: true,
      reviewEditData: "",
    });
  }
  async showAddModalFromTable() {
    await this.setState({
      show_modal: true,
      added_saved: "added",
    });
  }
  async showAlert() {
    await this.setState({ show_experience_added_alert: true });
  }
  async showDeletedAlert() {
    await this.setState({ show_experience_deleted_alert: true });
  }
  async handleNextClick() {
    this.props.isFormComplete(true);

    if (
      this.props.psrData.length > 0 &&
      this.props.contractType !== CONTRACT_TYPE_DESCRIPTIONS.MMLIS
    ) {
      this.props.toggleForm(FORM_ID.PERSONAL_SALES_RECORD);
    } else if (this.props.psrData.length <= 0) {
      this.props.toggleForm(FORM_ID.CCB_INTRO);
    } else {
      this.props.toggleForm(FORM_ID.CCB_INTRO);
    }
  }

  handleShowBackModal() {
    if (this.props.isCria || this.props.ia) {
      this.props.toggleForm(FORM_ID.PROFESSIONAL_DESIGNATION_CRIA);
    } else if (this.props.contractType === CONTRACT_TYPE_DESCRIPTIONS.MMLIS) {
      this.props.toggleForm(FORM_ID.BUSINESS_INFO);
    } else {
      this.props.toggleForm(FORM_ID.PROFESSIONAL_DESIGNATION);
    }
  }

  render() {
    const showToast =
      this.state.show_experience_added_alert ||
      this.state.show_experience_deleted_alert;

    const toastText = this.state.show_experience_added_alert
      ? `Your experience has been ${this.state.isEditToast ? "saved" : "added"} successfully.`
      : `Your experience has been deleted successfully.`;

    const closeToast = this.state.show_experience_added_alert
      ? this.closeAlert
      : this.closeDeletedAlert;

    return (
      <>
        <Toast
          closeToast={closeToast}
          showToast={showToast}
          toastText={toastText}
        />
        <div className="row">
          <div className="col-md-12">
            <h1>Employment History</h1>
          </div>
        </div>
        <div className="row" style={{ paddingBottom: "15px" }}>
          <div className="col-md-12">
            <h3 id="emp_hist_header">
              Please provide your employment history for the last 10 years,
              including any time contracted with MassMutual.
            </h3>
          </div>
        </div>
        <div className="row" style={{ paddingBottom: "15px" }}>
          <div className="col-md-12">
            <span
              id="emp_hist_intro"
              className="required-field-text"
              style={{ fontSize: "16px" }}
            >
              To account for military service, education, unemployment,
              homemaking, extended travel, or any other employment gaps lasting
              three months or more, please use the “Employment Break” tab on the
              Add Experience screen.
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {/* {this.state.emp_hist_data.length === 0 && ( */}
            <hr style={{ color: "#C1C9D5" }}></hr>
            {/* )} */}
            {/* {this.state.emp_hist_data.length < 1 && ( */}
            <button
              id="initial_add_emp_history"
              style={{
                marginRight: "25px",
                color: "#3174af",
                cursor: "pointer",
                border: "none",
                background: "none",
              }}
              onClick={() => this.showAddModalFromTable()}
            >
              <span className="icon-add"></span>
              <strong style={{ paddingLeft: "5px" }}>Add Experience</strong>
            </button>
            {/* )} */}
            {this.state.emp_hist_data.length > 0 && (
              <div
                style={{
                  padding: "0",
                  border: "none",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <EmploymentHistoryTable
                  data={this.state.emp_hist_data}
                  psrData={this.props.psrData}
                  showAddModal={this.showAddModalFromTable}
                  deleteData={this.deleteData}
                  reviewEditClick={this.reviewEditClick}
                  hasNYRegs={this.props.hasNYRegs}
                  industries={this.props.industries}
                ></EmploymentHistoryTable>
              </div>
            )}

            <NavigationButtons
              onBack={this.handleShowBackModal}
              onNext={this.handleNextClick}
              isLoading={false}
              isDisabled={this.state.is_next_disabled}
              nxtbtnid={"emp_hist_next"}
              bckbtnid={"emp_hist_back"}
            />
          </div>
        </div>
        <EmploymentHistoryModal
          isOpen={this.state.show_modal}
          actionCancel={this.closeAddModal}
          subId={this.state.oktasubid}
          candidateId={this.state.candidateId}
          showAlert={this.showAlert}
          showDeletedAlert={this.showDeletedAlert}
          reviewEditData={this.state.reviewEditData}
          hasNYRegs={this.props.hasNYRegs}
          industries={this.props.industries}
          contracttype={this.props.contractType}
        />
      </>
    );
  }
}

export default EmploymentHistoryForm;
